import { createUserWalletInvoice, fetchUserWalletInvoice } from '../../api/payments';

export const invoices = {
  effects: {
    async createWalletInvoice(createUserInvoiceRequest) {
      return createUserWalletInvoice(createUserInvoiceRequest);
    },
    async fetchUserWalletInvoice(invoiceId) {
      return fetchUserWalletInvoice(invoiceId);
    }
  },
  reducers: null,
  state: null
};
